/**
 * Copyright (C) 2025 Checkmk GmbH - License: GNU General Public License v2
 * This file is part of Checkmk (https://checkmk.com). It is subject to the terms and
 * conditions defined in the file COPYING, which is part of this source code package.
 */
import type { DynamicIcon } from 'cmk-shared-typing/typescript/icon'

export const getIconId = (icon: DynamicIcon | null | undefined): string | null => {
  if (!icon) {
    return null
  }
  return 'emblem' in icon ? icon.emblem : icon.id
}
